import { render } from "./WorkshiftsStamp.vue?vue&type=template&id=1c93f3ff"
import script from "./WorkshiftsStamp.vue?vue&type=script&lang=js"
export * from "./WorkshiftsStamp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__